import React from 'react';
import moment from 'moment';
// import { useTheme } from '../../../../theme-context';

const FailedJobsTable = ({
    rows,
    paginationData,
    paginationState,
    setPaginationState,
}: {
    rows?: any;
    paginationData?: any;
    paginationState?: any;
    setPaginationState?: any
}) => {
    // const { theme } = useTheme();

    return (
        <div className=''>
            <div className='overflow-x-auto max-h-[520px] overflow-y-auto border border-1 !rounded-xl dark:border-borderColor-darkMode'>
                <table className='min-w-full bg-white dark:bg-black dark:text-primary-dark'>
                    <thead className='bg-white dark:bg-black text-left text-sm font-medium text-black dark:text-primary-dark rounded-xl'>
                        <tr>
                            <th className='px-4 py-3'>Timestamp</th>
                            <th className='px-4 py-3'>Client/Template</th>
                            <th className='px-4 py-3'>Error Summary</th>
                            <th className='px-4 py-3'>Source File</th>
                            {/* <th className='px-4 py-3'>Actions</th> */}
                        </tr>
                    </thead>
                    <tbody>
                        {rows?.map((row: any) => (
                            <tr key={row.id} className='hover:bg-gray-50 dark:hover:bg-bgColor-darkMode text-sm'>
                                <td className={`px-4 py-4`}>{moment(row?.updatedAt).format('DD-MM-YYYY, hh:mm A')}</td>
                                <td className={`px-4 py-4`}>
                                    <p>{row?.createdBy?.name}</p>
                                    <p className='text-sm'>{row?.templateName}</p>
                                </td>
                                <td className={`px-4 py-4 text-[#EF4444]`}>{row?.errorSummary}</td>
                                <td className={`px-4 py-4`}>{row?.sourceFile}</td>
                                {/* <td className={`px-4 py-4`}>
                                    <div className='bg-[#F5F5F5] dark:bg-bgColor-darkMode py-1 px-3 flex flex-row items-center justify-center dark:text-primary-dark'>
                                        <img src={theme === 'dark' ? '/assets/admin-tab/retry-white.svg' : '/assets/admin-tab/retry.svg'} className='object-contain w-[22px] mr-3' />
                                    </div>
                                </td> */}
                            </tr>
                        ))}
                    </tbody>
                </table>
            </div>
        </div>
    );
};

export default FailedJobsTable;
